import React from 'react';

/**
 * Sheet — mobile-oriented panel used for "Mehr" nav, filter sheets and
 * full-screen detail views. `variant="bottom"` slides up from the bottom
 * with a backdrop; `variant="full"` covers the whole viewport (used when a
 * desktop docked panel has no room to dock on a narrow screen).
 */
export function Sheet({ open = false, onClose, title, variant = 'bottom', children, style = {} }) {
  if (!open) return null;

  const isFull = variant === 'full';

  return (
    <div
      className="a-no-scroll-body"
      role="dialog" aria-modal="true"
      style={{ position: 'fixed', inset: 0, zIndex: 900, display: 'flex', flexDirection: 'column', justifyContent: isFull ? 'stretch' : 'flex-end' }}
    >
      {!isFull && (
        <div onClick={onClose} style={{ position: 'absolute', inset: 0, background: 'rgba(10, 14, 23, 0.45)' }} />
      )}
      <div
        style={{
          position: 'relative', background: 'var(--surface-card)',
          width: '100%', maxHeight: isFull ? undefined : '85vh',
          height: isFull ? '100%' : undefined,
          display: 'flex', flexDirection: 'column',
          borderTopLeftRadius: isFull ? 0 : 'var(--radius-xl)',
          borderTopRightRadius: isFull ? 0 : 'var(--radius-xl)',
          boxShadow: 'var(--shadow-lg)', overflow: 'hidden',
          paddingBottom: 'var(--safe-bottom)',
          paddingLeft: 'var(--safe-left)', paddingRight: 'var(--safe-right)',
          paddingTop: isFull ? 'var(--safe-top)' : 0,
          ...style,
        }}
      >
        {!isFull && (
          <div style={{ display: 'flex', justifyContent: 'center', padding: '8px 0 0' }}>
            <span style={{ width: 36, height: 4, borderRadius: 999, background: 'var(--border-subtle)' }} />
          </div>
        )}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, padding: '14px 20px' }}>
          {title && (
            <span style={{ fontFamily: 'var(--font-sans)', fontSize: 'var(--text-h3)', fontWeight: 'var(--fw-semibold)', color: 'var(--text-strong)' }}>
              {title}
            </span>
          )}
          <button
            type="button" aria-label="Schließen" onClick={onClose}
            style={{
              marginLeft: 'auto', display: 'inline-flex', width: 44, height: 44,
              alignItems: 'center', justifyContent: 'center', border: 'none',
              background: 'transparent', color: 'var(--text-faint)', cursor: 'pointer',
              borderRadius: 'var(--radius-sm)',
            }}
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
          </button>
        </div>
        <div style={{ padding: '0 20px 20px', overflowY: 'auto', flex: 1 }}>
          {children}
        </div>
      </div>
    </div>
  );
}
